/* eslint-disable react/prop-types */
import React from 'react';
import styles from './OfferData.module.sass';
import { Link } from 'react-router-dom'
import OfferType from "../OfferType/OfferType";

const OfferData = (props) => {
    return (
        <div className={styles.itemsOffer}>

            <div className={styles.item}>
                <p className={styles.itemTitle}> Sua simulação </p>
                <div className={styles.typePlan}>
                    <OfferType inline={props.isDesktop} showIcon={true} type={props.productType}/>
                </div>
            </div>

            <div className={styles.item}>
                <p className={styles.itemTitle}> {'Valores aproximados ' + (props.simulationType === 'parcela' ? 'da parcela' : 'do crédito')} </p>
                <p className={styles.values}> 
                    <span>R$</span>
                    {props.value}
                </p>
            </div>

            <Link className={styles.link} to="/produtos">Fazer outra simulação </Link>
        </div>
    )
};

export default OfferData;
